import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function LoginPage({ onLogin }) {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');



        try {
            const apiUrl = process.env.REACT_APP_API_URL || `${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/`;
            const res = await axios.post(`${apiUrl}/auth/login`, {
                login,
                password,
            });

            const { token } = res.data;
            localStorage.setItem("token", token);
            if (onLogin) onLogin(); // Caso use contexto de auth
            navigate('/dashboard'); // ou onde for sua rota protegida
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setError('Credenciais inválidas.');
            } else {
                setError('Erro ao fazer login. Tente novamente mais tarde.');
            }
        }
    };

    return (
        <div className="relative flex justify-center items-center h-screen w-full overflow-hidden bg-slate-950">
            {/* Esferas Flutuantes Premium (Morphing Mesh) */}
            <div className="absolute top-0 -left-4 w-72 h-72 bg-purple-500 rounded-full mix-blend-screen filter blur-3xl opacity-30 animate-mesh"></div>
            <div className="absolute top-0 -right-4 w-72 h-72 bg-indigo-500 rounded-full mix-blend-screen filter blur-3xl opacity-30 animate-mesh animation-delay-2000"></div>
            <div className="absolute -bottom-8 left-20 w-72 h-72 bg-blue-500 rounded-full mix-blend-screen filter blur-3xl opacity-30 animate-mesh animation-delay-4000"></div>
            
            <div className="glass-panel p-10 flex flex-col items-center w-[400px] max-w-[90%] z-10 border-white/20">
                <h1 className="text-4xl font-bold text-white mb-2 tracking-wide">Vexor Finance</h1>
                <p className="text-gray-300 mb-8 text-sm">Entre com suas credenciais para continuar</p>
                
                <form onSubmit={handleLogin} className="flex flex-col w-full gap-4">
                    <div className="flex flex-col">
                        <label className="text-gray-300 text-sm mb-1 ml-1 font-medium">Usuário</label>
                        <input
                            type="text"
                            placeholder="Digite seu login"
                            value={login}
                            onChange={(e) => setLogin(e.target.value)}
                            required
                            className="glass-input"
                        />
                    </div>
                    <div className="flex flex-col mb-4">
                        <label className="text-gray-300 text-sm mb-1 ml-1 font-medium">Senha</label>
                        <input
                            type="password"
                            placeholder="Digite sua senha"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="glass-input"
                        />
                    </div>
                    
                    {error && <p className="text-red-400 text-sm text-center mb-2">{error}</p>}
                    
                    <button type="submit" className="glass-button w-full shadow-[0_0_15px_rgba(59,130,246,0.5)]">
                        Entrar na Plataforma
                    </button>
                </form>
            </div>
        </div>
    );
}
